module.exports = __webpack_public_path__ + "img/ca_visadebit.0eb14603.png";